export default __webpack_public_path__ + "static/media/admin.ccdd6ad7.svg";